import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import { IReviewPageInstance } from 'mod/review/useReviewPage';
import cn from 'classnames';
import { IReviewPage } from 'mod/review/interface';

type IProps = Pick<IReviewPageInstance, | 'withPictures' | 'onWithPicturesChange'> & {
    reviewPage: IReviewPage;
    className?: string;
};

export const ReviewsAssetsFilter: FC<IProps> = props => {
    const {
        className,
        reviewPage,
        withPictures,
        onWithPicturesChange,
    } = props;

    const { t } = useTrans();

    return (
        <div className={cn(className, 'flex')}>
            <div
                className={cn('g-item', { 'g-active': withPictures == 0 })}
                onClick={() => onWithPicturesChange(0)}
            >
                {t('web_product_review_all_reviews')} ({reviewPage.totalReviewNum || 0})
            </div>

            {!!reviewPage!.totalWithPictureNum && (
                <div
                    className={cn('g-item', { 'g-active': withPictures == 1 })}
                    onClick={() => onWithPicturesChange(1)}
                >
                    {t('web_product_review_with_photo')} ({reviewPage.totalWithPictureNum || 0})
                </div>
            )}

        </div>
    )
};
